export default __webpack_public_path__ + "static/media/document-success.5674df93.svg";